
/**
 * @component Section
 *
 * @note we could use an intersection observer to trigger events
 * on focus.
 *
 * @todo section should provide intersection capabilities
 *
 * @prop {String} title (generate unique identifier)
 * @prop {String} tag (to change the section tag, section by default)
 * @public
 */

export default {
  name: 'SectionComponent',
  props: {
    title: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'section',
    },
  },
  computed: {
    /**
       * Create section identifier based on the given id.
       *
       * @return {String}
       * @private
       */

    identifier() {
      const { title } = this;
      return title && title.toLowerCase().trim().replace(/ /g, '-');
    },
  },
};
